/**
 * RESPONSIBILITY: put a new page at its top when the route changes.
 *
 * A hash route the browser cannot find an element for leaves the scroll position exactly
 * where it was. So clicking a ministry card halfway down the home page swapped the whole
 * page underneath the reader and left them in the middle of the new one — which read as
 * a broken page rather than as a navigation.
 *
 * useLayoutEffect, not useEffect: after paint the reader sees one frame at the old offset
 * before it jumps, which is the flicker this exists to avoid.
 */
import { useLayoutEffect, useRef } from 'react';

export function useScrollTop(key: string): void {
  const first = useRef(true);

  useLayoutEffect(() => {
    // Not on arrival. A reload should keep the position the browser restored — this is
    // about MOVING between pages, not about landing on one.
    if (first.current) { first.current = false; return; }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [key]);
}
